import React, { useEffect, useRef, useState } from "react";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import StarIcon from "@mui/icons-material/Star";
import axios from "axios";

import dayjs, { Dayjs } from "dayjs";
import useThemeColors from "../vehicle/ThemeColors";
import { Loader } from "react-bootstrap-typeahead";
import minMax from "dayjs/plugin/minMax";
import {
    useConsentMasterQuery,
    useGetGeoLocationMutation,
} from "../../Services/vehicle/Vehicle";
import "./workshopcard.scss";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
dayjs.extend(minMax);

const WorkshopCard = ({
    setWorkshopId,
    storedGeoLoaction,
    setStoreVehicleInfo,
    storeVehicleInfo,
    // cartItems,
    workshopId,
    setLiftingSlot,
    setIsCheckoutClicked,
    // setCartItems,
    setCurrentStep,
    currentStep,
    selectedSubServices,
    servicesWithSelections,
    confimrButtonClicked,
    selectedSubServiceNames,
    selectedServiceNames,
    onClose,
    serviceRecord,
    setSlotClicked,
    slotClicked,
    homeApiData,
    setWorkshopData,
    workshopData
}) => {
    const [getWorkshopData, setGetWorkshopData] = useState([]);

    // const [workshopData, setWorkshopData] = useState<any>({});
    const [isLoading, setIsLoading] = useState(false);
    const [isGarageListed, setIsGarageListed] = useState(0);
    const [consentData, setConsentData] = useState([]);
    const [vehiclesData, setVehiclesData] = useState([]);
    const [isExpanded, setIsExpanded] = useState(true);
    const [height, setHeight] = useState("0px");
    const [location, setLocation] = useState("");
    const [geoLocationTrigger, { status }] = useGetGeoLocationMutation();
    const [storeGeoLocationData, setStoreGeoLocationData] = useState<any>("");

    const contentRef = useRef(null);
    const navigate = useNavigate()

    useEffect(() => {
        if (contentRef.current) {
            setHeight(
                isExpanded ? `${contentRef.current.scrollHeight}px` : "0px"
            );
        }
    }, [isExpanded]);

    const { data: getMasterData } = useConsentMasterQuery({});

    useEffect(() => {
        if (getMasterData) {
            setConsentData(getMasterData?.data);
        }
    }, [getMasterData]);

    const token = localStorage.getItem("customer-token");
    const fetchingTenant = window.location.hostname.split(".")[0];
    const apiPort = process.env.REACT_APP_API_PROTOCOL;

    const getWorkshopNearBy = async () => {
        const workshopPayload = {
            latitude: storedGeoLoaction?.latitude,
            longitude: storedGeoLoaction?.longitude,
            brand: storeVehicleInfo?.brand,
            model: storeVehicleInfo?.model,
            fuel_type: storeVehicleInfo?.fuel,
            radius_km: 20,
            sub_service_type: selectedSubServices,
        };
        try {
            setIsLoading(true);

            const response = await axios.post(
                `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/gc/garage-search/search/`,
                workshopPayload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response?.data) {
                // toast.success(response?.data?.message)
                setGetWorkshopData(response?.data?.data);
                setIsGarageListed(response?.data?.garage_found);
            }
        } catch (error) {
            console.error("Error fetching profile:", error);
        } finally {
            setIsLoading(false); // 🟢 Stop loader
        }
    };

    const getWorkshopByFind = async () => {
        const workshopPayload = {
            latitude: storeGeoLocationData?.latitude,
            longitude: storeGeoLocationData?.longitude,
            brand: storeVehicleInfo?.brand,
            model: storeVehicleInfo?.model,
            fuel_type: storeVehicleInfo?.fuel,
            radius_km: 20,
            sub_service_type: selectedSubServices,
        };
        try {
            setIsLoading(true);

            const response = await axios.post(
                `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/gc/garage-search/search/`,
                workshopPayload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response?.data) {
                // toast.success(response?.data?.message)
                setGetWorkshopData(response?.data?.data);
                setIsGarageListed(response?.data?.garage_found);
            }
        } catch (error) {
            console.error("Error fetching profile:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const getLocation = async (e: any) => {
        e.preventDefault();
        const locationPayload = {
            address: location,
        };
        try {
            const response = await geoLocationTrigger(locationPayload);

            setStoreGeoLocationData(response?.data);
            console.log(response?.data, "working");
            if (response?.data) {
                toast.success("Location fetched successfully");
            } else if (response?.error) {
                toast.error("unabel to find the location");
            }
        } catch (error) {}
    };

    useEffect(() => {
        if (confimrButtonClicked) {
            getWorkshopNearBy();
        }
    }, [confimrButtonClicked]);

    useEffect(() => {
        console.log("working2");
        console.log(storeGeoLocationData, "working");
        if (!!storeGeoLocationData) {
            console.log("working");
            getWorkshopByFind();
        }
    }, [storeGeoLocationData]);

    const slotSelectHandler = () => {
        navigate('/service-summary')

        setSlotClicked(true);
        setLiftingSlot(true);
    };

    const {
        selectedBorderColor,
        selectedButtonBackgoundColors,
        selectedButtonColors,
    } = useThemeColors();

    const fetchVehicle = async () => {
        try {
            const response = await axios.get(
                `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/gc/vehicles/`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            setVehiclesData(response?.data?.data);
        } catch (error) {
            console.error("Error fetching profile:", error);
        }
    };

    useEffect(() => {
        fetchVehicle();
    }, []);

    return (
        <div
            className="workshop-cont"
            style={{
                display: "flex",
                position: "relative",
                width: "100%",
                height: "100%",
            }}
        >
            {/* Left Workshop names*/}

            {currentStep === 3 && !slotClicked && (
                // STart

                <div className="workshop-sub-cont" style={{width: window.innerWidth >= 1024 ? "30%" : "100%"}}>
                    {!isLoading && getWorkshopData?.length > 0 ? (
                        <div
                            className="available-workshop-heading"
                            style={{ textAlign: "center", fontSize: "16px" }}
                        >
                            Available Workshops
                        </div>
                    ) : !isLoading && getWorkshopData?.length === 0 ? (
                        <div
                            className="available-workshop-heading"
                            style={{ textAlign: "center", fontSize: "16px" }}
                        >
                            No Workshops Found
                        </div>
                    ) : null}

                    <>
                        {!slotClicked ? (
                            isLoading ? (
                                <div
                                    style={{
                                        textAlign: "center",
                                        padding: "20px",
                                        fontSize: "16px",
                                    }}
                                >
                                    Loading workshops... <Loader />
                                </div>
                            ) : (
                                <>
                                    {getWorkshopData?.map((workshop, index) => (
                                        <div
                                            key={index}
                                            className="workshop-name-cont"
                                            style={{
                                                borderRadius: "12px",
                                                padding: "16px",
                                                backgroundColor: "#fff",
                                                boxShadow:
                                                    "0 2px 8px rgba(0,0,0,0.1)",
                                                display: "flex",
                                                gap: "16px",
                                                alignItems: "center",
                                                maxWidth: "100%",
                                                border:
                                                    workshopId === workshop?.id
                                                        ? "1px solid red"
                                                        : "",
                                                cursor: "pointer",
                                            }}
                                            onClick={() => {
                                                setWorkshopId(workshop?.id);
                                                setWorkshopData(workshop);
                                            }}
                                        >
                                            <div
                                                className="workshop-name"
                                                // style={{ flex: 1 }}
                                            >
                                                <h3 style={{ margin: "0" }}>
                                                    {workshop?.name}
                                                </h3>
                                                <p
                                                    style={{
                                                        margin: "4px 0",
                                                        color: "#555",
                                                    }}
                                                >
                                                    {workshop?.address}
                                                </p>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        gap: "12px",
                                                        alignItems: "center",
                                                        margin: "4px 0",
                                                    }}
                                                >
                                                    <span
                                                        style={{
                                                            display: "flex",
                                                            alignItems:
                                                                "center",
                                                            color: "#888",
                                                        }}
                                                    >
                                                        <LocationOnIcon
                                                            fontSize="small"
                                                            style={{
                                                                color: "red",
                                                                marginRight: 4,
                                                            }}
                                                        />
                                                        {
                                                            workshop?.distance_text
                                                        }
                                                    </span>
                                                    <span
                                                        style={{
                                                            display: "flex",
                                                            alignItems:
                                                                "center",
                                                            color: "#888",
                                                        }}
                                                    >
                                                        <AccessTimeIcon
                                                            fontSize="small"
                                                            style={{
                                                                color: "#ff9800",
                                                                marginRight: 4,
                                                            }}
                                                        />
                                                        {
                                                            workshop?.duration_text
                                                        }
                                                    </span>
                                                </div>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "12px",
                                                        marginTop: "6px",
                                                    }}
                                                >
                                                    <span
                                                        style={{
                                                            display: "flex",
                                                            alignItems:
                                                                "center",
                                                            fontSize: "14px",
                                                            color: "#444",
                                                        }}
                                                    >
                                                        <StarIcon
                                                            fontSize="small"
                                                            style={{
                                                                color: "#ffc107",
                                                                marginRight: 4,
                                                            }}
                                                        />
                                                        {workshop?.rating}
                                                    </span>
                                                    <span
                                                        style={{
                                                            background:
                                                                "rgb(242, 93, 33)",
                                                            color: "white",
                                                            padding: "2px 8px",
                                                            borderRadius:
                                                                "10px",
                                                        }}
                                                    >
                                                        {
                                                            workshop?.matching_services_count
                                                        }{" "}
                                                        Services found out of{" "}
                                                        {
                                                            workshop?.total_requested_services
                                                        }
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </>
                            )
                        ) : null}
                    </>
                </div>
            )}

            {/* END */}
{/* 
            {slotClicked && (
                <BookingSection
                    onClose={onClose}
                    setSlotClicked={setSlotClicked}
                    setCurrentStep={setCurrentStep}
                    workshopId={workshopId}
                    setIsCheckoutClicked={setIsCheckoutClicked}
                    storeVehicleInfo={storeVehicleInfo}
                    workshopData={workshopData}
                    homeApiData={homeApiData}
                />
            )} */}

            {/* RIGHT side panel end */}

            {!slotClicked && (
                <>
                    {window.innerWidth >= 1024 && (
                        <div
                            style={{
                                flex: 1,
                                height: "98%",
                                boxShadow: "0 0 10px #0064b4",
                                display: "flex",
                                flexDirection: "column",
                                borderRadius: 8,
                                overflow: "hidden",
                                width: currentStep !== 3 ? "100%" : "",
                                // margin: "10px 20px"
                            }}
                        >
                            {/* Header */}
                            <div
                                style={{
                                    padding: "20px",
                                    borderBottom: "1px solid #ddd",
                                }}
                            >
                                <h2
                                    style={{
                                        margin: 0,
                                        color: "#007bff",
                                        fontWeight: 600,
                                        fontSize: 20,
                                        fontFamily: "karbon-semi",
                                    }}
                                >
                                    LOCATION
                                </h2>
                                <p
                                    style={{
                                        fontSize: 12,
                                        color: "#666",
                                        fontFamily: "karbon-medium",
                                    }}
                                >
                                    Find a garage by entering your zip code,
                                    name or address or let the application find
                                    you.
                                </p>
                            </div>

                            {/* Map Section */}

                            {window.innerWidth >= 1024 && (
                                <div style={{ flex: 1, position: "relative" }}>
                                    <div
                                        style={{
                                            display: "flex",
                                            gap: 10,
                                            marginTop: "0px",
                                            padding: "5px 10px",
                                        }}
                                    >
                                        <input
                                            type="text"
                                            placeholder="ZIP CODE"
                                            disabled={isLoading}
                                            style={{
                                                flex: 1,
                                                padding: "10px 12px",
                                                borderRadius: 4,
                                                border: "1px solid #ccc",
                                                fontSize: 14,
                                                opacity: isLoading ? 0.7 : 1,
                                                cursor: isLoading ? 'not-allowed' : 'text',
                                                backgroundColor: isLoading ? '#f5f5f5' : 'white'
                                            }}
                                            onChange={(e) =>
                                                setLocation(e.target.value)
                                            }
                                        />
                                        <button
                                            disabled={isLoading}
                                            style={{
                                                background: isLoading ? "#ccc" : "#FF5722",
                                                color: "#fff",
                                                border: "none",
                                                borderRadius: 4,
                                                padding: "10px 15px",
                                                cursor: isLoading ? 'not-allowed' : 'pointer',
                                                fontWeight: 500,
                                                fontFamily: "karbon-semi",
                                            }}
                                            onClick={getLocation}
                                        >
                                            {isLoading ? (
                                                'Loading...'
                                            ) : (
                                                <>
                                                    <span
                                                        role="img"
                                                        aria-label="find"
                                                        style={{
                                                            marginRight: 5,
                                                            fontFamily: "karbon-semi",
                                                        }}
                                                    >
                                                        🎯
                                                    </span>
                                                    FIND ME
                                                </>
                                            )}
                                        </button>
                                    </div>

                                    <iframe
                                        title="garage-map"
                                        width="100%"
                                        height="60vh"
                                        style={{ border: 0, height : "60vh" }}
                                        loading="lazy"
                                        allowFullScreen
                                        src={`https://www.google.com/maps?q=${
                                            workshopData?.latitude || 28.6072042
                                        },${
                                            workshopData?.longitude ||
                                            77.3808272
                                        }&z=6&output=embed`}
                                    />
                                </div>
                            )}

                            {/* Bottom Button */}
                            {!slotClicked && (
                                <div
                                    style={{
                                        padding: "20px",
                                        textAlign: "center",
                                        position: "relative",
                                        // bottom: "50px",
                                        // left: "50%",
                                    }}
                                >
                                    {currentStep === 3 && (
                                        <div className="serching-garages">
                                            {isLoading ? (
                                                <>
                                                    Searching Garages...
                                                    <Loader />
                                                </>
                                            ) : (
                                                <button
                                                    onClick={slotSelectHandler}
                                                    disabled={!isGarageListed}
                                                    style={{
                                                        position: "absolute",
                                                        left: "35%",
                                                        bottom: "10%",

                                                        width: "30%",
                                                        padding: "12px 25px",
                                                        borderRadius: "30px",
                                                        background: `${
                                                            selectedButtonBackgoundColors ||
                                                            "#FF5722"
                                                        }`,
                                                        color: `${
                                                            selectedButtonColors ||
                                                            "#fff"
                                                        }`,
                                                        border: `1px solid ${
                                                            selectedBorderColor ||
                                                            "#FF5722"
                                                        }`,
                                                        fontSize: 16,
                                                        fontWeight: "bold",
                                                        cursor: isGarageListed
                                                            ? "pointer"
                                                            : "not-allowed",
                                                        opacity: isGarageListed
                                                            ? 1
                                                            : 0.6,
                                                        fontFamily:
                                                            "karbon-semi",
                                                    }}
                                                >
                                                    {isGarageListed
                                                        ? "CONTINUE"
                                                        : "No Garage Found"}
                                                </button>
                                            )}
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    )}
                </>
            )}

            {/* {openVehicleModa && (
                <VehicleSelect
                    vehicleData={vehiclesData}
                    storeVehicleInfo={storeVehicleInfo}
                    setStoreVehicleInfo={setStoreVehicleInfo}
                    onClose={closeModal}
                    setCurrentStep={1}
                />
            )} */}
        </div>
    );
};

export default WorkshopCard;
